"use client";

// packages/eden-table/src/components/ColGroup.jsx
import { Children, useContext } from "react";
import ColumnHidingContext from './ColumnHiding/Context.js';
import { jsx } from "react/jsx-runtime";
var ColGroup = ({ id, children, noSorting, ...props }) => {
  noSorting;
  const { hiddenColumns } = useContext(ColumnHidingContext);
  const hidden = hiddenColumns.includes(id) || Children.count(children) > 0 && Children.toArray(children).every(
    (child) => hiddenColumns.includes(child.props.id)
  );
  return /* @__PURE__ */ jsx("colgroup", { hidden, id, ...props, children });
};
ColGroup.displayName = "ColGroup";
var ColGroup_default = ColGroup;
export {
  ColGroup_default as default
};
